import { convertSecondsToTimeString } from '@goldcast/player-config/src/utils/timeUtils';
import { VideoSegment } from '@goldcast/player-config/src/types/RemotionPlayerConfigTypes/Segment/VideoSegment';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';

// dragStart/dragEnd are temporary offsets (in seconds) applied while the user is
// actively dragging a trim handle. They let the displayed duration update in
// real-time during the drag gesture, before the trim is committed to clip data.
export default function TotalVideoSegmentDuration({
  segment,
  showShortTime,
  dragStart,
  dragEnd
}: {
  segment: VideoSegment;
  showShortTime?: boolean;
  dragStart?: number;
  dragEnd?: number;
}) {
  const { fps } = useClipsContext();

  const baseDuration = segment.currentBounds
    ? (segment.currentBounds?.toFrame - segment.currentBounds?.fromFrame) / fps
    : 0;

  const dragStartOffset = dragStart || 0;
  const dragEndOffset = dragEnd || 0;
  const duration = baseDuration + dragEndOffset - dragStartOffset;

  if (showShortTime && duration < 3600) {
    return convertSecondsToTimeString(duration || 0, 'mm:ss');
  }
  return convertSecondsToTimeString(duration || 0, 'HH:mm:ss');
}
